import {all, fork ,call, put, takeEvery, takeLatest  } from 'redux-saga/effects'
import { push } from 'react-router-redux';
import NetworkHandler from '../net/NetworkHandler'
import StorageHandler from '../storage/StorageHandler';
import * as ACTIONS from '../containers/constants';
import { error ,success } from '../components/Alert/actions';
import {updateInfodexLinked} from '../containers/LinkedInfodex/actions';
const storageHandler = new StorageHandler();

function* getInfodexLinked(action){
	
  const Network = new NetworkHandler();
  try{
      const response = yield Network.requestGetLinkedInfodex(action.payload);
	
      if (!(response instanceof Error)) {
          
          yield put(
                updateInfodexLinked(
                response
              )
          );

        } else {
          yield put(
            error({
              message: 'Unable to load Linked Infodex',
            })
          );
      }
  }catch (errorMsg) {
      yield put(
          error({
           message: `Unable to load Linked Infodex, please try again.${errorMsg}`,
          })
      );
  }
	
}

function* getInfodexLinkedInfo(action){

  const Network = new NetworkHandler();
  try{
      const response = yield Network.requestGetLinkedInfodexInfo(action.payload);
      
      if (!(response instanceof Error)) {
		  
          //localStorage.setItem("joinedPlace",JSON.stringify(response));
		  
          yield put(
                updateInfodexLinked(
                response
              )
            );
			
        } else {
			
          yield put(
            error({
              message: 'Unable to load Linked Infodex',
            })
          );
		  
      }
  }catch (errorMsg) {
      yield put(
          error({
           message: `Unable to load Linked Infodex, please try again.${errorMsg}`,
          })
      );
  }
}

function* updateInfodexCryodexLink(action){

  const Network = new NetworkHandler();
  
  try{
	  
	  const response = Network.requestGetLinkedInfodexInfo(action.payload);
	  
    	//localStorage.setItem("joinedPlace",JSON.stringify(response));
		
          yield put(
                updateInfodexLinked(
                response
              )
          );  
      
  }catch (errorMsg) {
      yield put(
          error({
           message: `Unable to load Linked Infodex, please try again.${errorMsg}`,
          })
      );
  }
}

function* unlinkCryodexInfodexLink(action){

  const Network = new NetworkHandler();
  try{
     
      const response = yield Network.requestCryodexInfodexUnlink(action.payload);
      
      if (!(response instanceof Error)) {
		 //localStorage.removeItem("joinedPlace");
          yield put(
                updateInfodexLinked(
                response
              )
          );

        } else {
          yield put(
            error({
              message: 'Unable to load Linked Infodex',
            })
          );
      }
  }catch (errorMsg) {
      yield put(
          error({
           message: `Unable to load Linked Infodex, please try again.${errorMsg}`,
          })
      );
  }
}

export default function* usersSagas() {
  
  yield takeLatest(ACTIONS.CRYODEX_INFODEX_LINK_GET, getInfodexLinked);
  yield takeLatest(ACTIONS.CRYODEX_INFODEX_LINKED_GET, getInfodexLinkedInfo);
  yield takeLatest(ACTIONS.CRYODEX_CRYODEX_INFODEX_UNLINK, unlinkCryodexInfodexLink);
  yield takeLatest(ACTIONS.CRYODEX_CRYODEX_INFODEX_LINK_UPDATE, updateInfodexCryodexLink);
}

